export const SERIES = {
    title: "Deadly Ambition",
    studio: "Celestial Light Studios",
    logline:
        "A devout journalist investigates a high-profile murder — and falls for the accused: a man vilified by his community, romanticised by the public, and bound to a world governed by dark, unseen forces.",
    meta: ["PILOT COMPLETE", "6 × 45 MIN", "DRAMA / MYSTERY / DARK ROMANCE", "SEASON ONE FULLY SCRIPTED"],
    email: "bianca@celestiallight.com.au",
    phone: "+61 410 812 997",
    website: "https://www.celestialstudio.org",
};

export const IMAGES = {
    hero: "/stills/hero-banner.jpg",
    atmosphere1: "/stills/staircase.jpg",
};

export const MARQUEE_ITEMS = [
    "TRUTH IS A DANGEROUS OBSESSION",
    "YOU MEETS NANCY DREW",
    "PILOT COMPLETE — SEASON ONE SCRIPTED",
    "THE OSIRICA SAGA",
    "AN AUSTRALIAN GOTHIC",
    "CELESTIAL LIGHT STUDIOS",
];

export const BEATS = [
    {
        num: "01",
        title: "The Murder",
        text: "Liana Castillo arrives at college seeking a fresh start after a scandal. Then her best friend is murdered — and Dominic Hale, the man she's falling for, becomes the prime suspect.",
    },
    {
        num: "02",
        title: "The Obsession",
        text: "An aspiring journalist with OCD, Liana begins to investigate. The investigation becomes fixation, dragging her, Dominic and their friends into a dark chapter of the town's history.",
    },
    {
        num: "03",
        title: "The Spotlight",
        text: "The case turns public fodder in the age of true-crime obsession. Every private secret becomes content — and every answer implicates someone she loves.",
    },
];

export const THEMES = [
    "Truth",
    "Ambition",
    "Obsession",
    "Secrets",
    "Loyalty",
    "Family & Faith",
    "Morality",
    "True-Crime Culture",
    "Identity",
];

export const CAST = [
    { id: "bianca-nunez", actor: "Bianca K. Nuñez", character: "Liana Castillo", img: "/cast/bianca-nunez.jpg" },
    { id: "alexander-lloyd", actor: "Alexander Lloyd", character: "Dominic Hale", img: "/cast/alexander-lloyd.jpg" },
    { id: "camila-ponte-alvarez", actor: "Camila Ponte Alvarez", character: "Sofia Castillo", img: "/cast/camila-ponte-alvarez.jpg" },
    { id: "caitlin-lopez", actor: "Caitlin Lopez", character: "Vivienne Peters", img: "/cast/caitlin-lopez.jpg" },
    { id: "john-stone", actor: "Jonathan Stone", character: "Octavious León", img: "/cast/john-stone.jpg" },
    { id: "elias-jasser", actor: "Elias Jasser", character: "Julian Farid", img: "/cast/elias-jasser.jpg" },
    { id: "helen-hailu", actor: "Helen Hailu", character: "Brielle Sinclair", img: "/cast/helen-hailu.jpg" },
    { id: "izaak-love", actor: "Izaak Love", character: "Cole Mancini", img: "/cast/izaak-love.jpg" },
    { id: "taliesin-don", actor: "Taliesin Don", character: "Henrietta León", img: "/cast/taliesin-don.jpg" },
];

export const FORMAT_FACTS = [
    ["FORMAT", "6 × 45-minute episodes — one-hour drama"],
    ["STATUS", "Pilot complete"],
    ["SCRIPTS", "Season One fully scripted"],
    ["PACKAGE", "Pilot screenplay · pitch trailer · Season One scripts"],
    ["STORY IP", "Companion feature currently in production"],
    ["RIGHTS", "International rights available"],
    ["LAUNCH MARKETS", "United States · United Kingdom · Australia · Brazil"],
];

export const AUDIENCE_PILLARS = [
    {
        id: "dark-academia",
        genre: "Dark Academia",
        stat: "14B+",
        statLabel: "#BookTok views in Brazil alone — TikTok sponsored the São Paulo Book Biennial",
        text: "A canon already in readers' hands: The Secret History, The Atlas Six, Babel, Ninth House. The aesthetic has an audience; it doesn't yet have its defining screen series.",
    },
    {
        id: "true-crime",
        genre: "True Crime",
        stat: "~80%",
        statLabel: "of true-crime podcast listeners are women — 2× as likely as men to listen regularly",
        text: "18–29-year-olds consume more true-crime content weekly than any other cohort, and true-crime fans average 7 hours of podcast listening a week. Gen Z's defining genre habit.",
    },
    {
        id: "dark-romance",
        genre: "Dark Romance",
        stat: "440.6M",
        statLabel: "viewing hours for YOU Season 4 on Netflix — the romanticised-villain effect, proven at scale",
        text: "Audiences don't just forgive magnetic villains — they organise fandoms around them. Deadly Ambition builds its central love story on exactly that mechanic.",
    },
];

export const MARKETS = [
    {
        id: "us",
        name: "United States",
        text: "Home base of the true-crime podcast boom and the dark-academia BookTok canon.",
    },
    {
        id: "uk",
        name: "United Kingdom",
        text: "One in five podcast listeners regularly consume true crime. The cultural home of the gothic-campus aesthetic.",
    },
    {
        id: "au",
        name: "Australia",
        text: "High-engagement BookTok market with a YA-romantasy / true-crime crossover — and the series' home ground.",
    },
    {
        id: "br",
        name: "Brazil",
        text: "Latin America's largest true-crime market — crime and psychological-suspense book sales up 25% in two years, primed and underserved by English-language adaptations.",
    },
];

export const COMPS = [
    {
        id: "you",
        title: "YOU",
        source: "Netflix",
        why: "The romanticised-villain mechanic — 440.6M viewing hours in Season 4 alone.",
    },
    {
        id: "nancy-drew",
        title: "Nancy Drew / Veronica Mars",
        source: "The Lineage",
        why: "The amateur-investigator tradition Liana Castillo inherits — solving the cases her institutions won't.",
    },
    {
        id: "secret-history",
        title: "The Secret History",
        source: "Donna Tartt",
        why: "The foundational dark-academia text informing the series' aesthetic and thematic DNA.",
    },
    {
        id: "da-vinci-code",
        title: "The Da Vinci Code",
        source: "The Mythology",
        why: "Ancient knowledge and secret societies whose influence extends into the modern world.",
    },
    {
        id: "vampire-diaries",
        title: "The Vampire Diaries",
        source: "The CW",
        why: "Proof that a young, devoted fandom sustains a mythology-rich genre series for years.",
    },
];

export const SAGA_PROPERTIES = [
    {
        id: "deadly-ambition",
        title: "Deadly Ambition",
        format: "TELEVISION SERIES — ANCHOR TITLE",
        status: "Pilot complete · Season One scripted",
        text: "The lead television title of the saga. A college journalist, a murdered best friend, a charismatic suspect — and a town whose secrets refuse to stay buried.",
    },
    {
        id: "the-hermetica",
        title: "The Hermetica",
        format: "FEATURE FILM",
        status: "In production",
        text: "A college outsider suspects her Occult Studies classmates are hiding a secret they would kill to protect — when one of them is found murdered. Pitch proposal and trailer available on request.",
    },
    {
        id: "wicked-minds",
        title: "Book Saga",
        format: "THE BOOK SERIES",
        status: "Book One on Substack · Book Two: A College of Deadly Ambitions",
        text: "Six students in Occult Studies 101 at an elite private college, whose friendships and rivalries unravel as strange mysteries lead into the buried secrets of the town's founding families. By Bianca K. Nuñez — built in public on Substack, so the fandom forms before the book reaches a shelf.",
        covers: [
            { src: "/books/wicked-minds.png", alt: "A College of Wicked Minds — Book One cover, by Bianca K. Nuñez" },
            { src: "/books/deadly-ambitions.png", alt: "A College of Deadly Ambitions — Book Two cover, by Bianca K. Nuñez" },
        ],
    },
];

export const DECK_ROLES = [
    "Streaming Platform / Acquisitions",
    "Sales Agent / Distributor",
    "Producer / Production Company",
    "Press / Media",
    "Other",
];

export const DECK_INCLUDES = [
    "Pilot screenplay",
    "Season One scripts — fully written",
    "Pitch trailer",
    "The Osirica Saga franchise brief",
];
